import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const containerBaseStyle = css`
  display: flex;
  position: relative;

  &:before {
    content: '';
    height: 100%;
    flex-shrink: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const containerSizeStyles = {
  small: css`
    min-height: 24px;
    max-width: 450px;
    &:before {
      width: 4px;
      border-radius: ${theme.borderRadius.small} 0 0 ${theme.borderRadius.small};
    }
  `,
  medium: css`
    min-height: 40px;
    max-width: 700px;
    &:before {
      width: 6px;
      border-radius: ${theme.borderRadius.medium} 0 0 ${theme.borderRadius.medium};
    }
  `,
  large: css`
    min-height: 72px;
    max-width: 700px;
    &:before {
      width: 8px;
      border-radius: ${theme.borderRadius.medium} 0 0 ${theme.borderRadius.medium};
    }
  `,
};

export const containerStatusStyles = {
  warn: css`
    &:before {
      background-color: ${theme.colors.warning50};
    }
  `,
  success: css`
    &:before {
      background-color: ${theme.colors.success50};
    }
  `,
  error: css`
    &:before {
      background-color: ${theme.colors.critical50};
    }
  `,
  info: css`
    &:before {
      background-color: ${theme.colors.primary50};
    }
  `,
  premium: css`
    &:before {
      background-color: ${theme.colors.secondary.seaweed50};
    }
  `,
};

export const contentBaseStyle = css`
  color: ${theme.colors.neutral90};
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;

  > :first-child {
    flex-shrink: 0;
  }
`;

export const contentSizeStyles = {
  small: css`
    padding: ${theme.spacing(0.5)};
    padding-left: calc(${theme.spacing(0.5)} + 4px);
    gap: ${theme.spacing(0.5)};
    border-radius: ${theme.borderRadius.small};
    border: none;
  `,
  medium: css`
    padding: ${theme.spacing(1)};
    padding-left: calc(${theme.spacing(1)} + 6px);
    gap: ${theme.spacing(1)};
    border-radius: ${theme.borderRadius.medium};
  `,
  large: css`
    padding: ${theme.spacing(2)};
    padding-left: calc(${theme.spacing(2)} + 8px);
    gap: ${theme.spacing(2)};
    border-radius: ${theme.borderRadius.medium};
  `,
};

export const contentStatusStyles = {
  warn: css`
    background-color: ${theme.colors.warning5};
    border: 1px solid ${theme.colors.warning50};
  `,
  success: css`
    background-color: ${theme.colors.success5};
    border: 1px solid ${theme.colors.success50};
  `,
  error: css`
    background-color: ${theme.colors.critical5};
    border: 1px solid ${theme.colors.critical50};
  `,
  info: css`
    background-color: ${theme.colors.primary5};
    border: 1px solid ${theme.colors.primary50};
  `,
  premium: css`
    background-color: ${theme.colorsV2.seaweed50(10)};
    border: 1px solid ${theme.colors.secondary.seaweed50};
  `,
};
